import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00c54552")

_pushScopeId("data-v-00c54552")
const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = { class: "content content-width" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "spacer" }, null, -1)
const _hoisted_4 = { class: "mt-auto" }
const _hoisted_5 = {
  href: "mailto:contact@deinjobfuchs.de",
  class: "help-button text text--size-22 text--semi-bold text--color-white"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { id: "modal-wrapper" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FooterVue = _resolveComponent("FooterVue")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "navigation", {}, undefined, true),
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "content", {}, undefined, true),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_FooterVue)
    ]),
    _createVNode("a", _hoisted_5, _toDisplayString(_ctx.$trans("navigation.help-button")), 1),
    _hoisted_6
  ]))
})